import { render } from "./BlockRate.vue?vue&type=template&id=59e08c5c"
import script from "./BlockRate.vue?vue&type=script&lang=js"
export * from "./BlockRate.vue?vue&type=script&lang=js"

import "./BlockRate.vue?vue&type=style&index=0&id=59e08c5c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__